import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import * as lookup from "../../../../static/lookup.json"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { PageContext } from "../../context/pageContext"
import { ErrorContext } from "../../context/errorContext"
import { JourneyContext } from "../../context/journeyContext"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  uploadDocument,
  saveApplication,
  fetchApplicationDetails,
  sendEmailBI,
  s3uploadPdfBI,
  whatsAppOptin,
  getTOFpaymentReceipt,
  saveTransactionDetails,
  updateUserTrackerDetails
} from "../../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  findRiderSA,
  findRiderSAPercent,
  getSourceFromChannel,
  transformReceiptToTransaction
} from "../../services/helperFunctions"
import {
  errorToastr,
  successToastr,
  clearToastr,
} from "../../../services/error-handler"
import { wordCapital, lineCapital, applyComma, calculateAge } from '../../../shared/functions'
export default function BiTitaniumPlusPlan(props){
  let [isactive, setIsActive] = useState(true)
    const [sectionState, setSectionState] = useContext(SectionContext)
    const [pageState, setPageState] = useContext(PageContext)
    const [errorState, setErrorState] = useContext(ErrorContext);
    const [journeyState, setJourneyState] = useContext(JourneyContext)
    const [conditionState, setConditionState] = useContext(ConditionContext)
  
    const [allJourneyData, setAllJourneyData] = useState()
    const [biApiData, setBiApiData] = useState()
    const [fundValue, setFundValue] = useState()
    const [payNowOrLater, setPayNowOrLater] = useState("now")
    const [pdfData, setPdfData] = useState("")
    const [agreeToDeclaration, setAgreeToDeclaration] = useState(true)
    const [proceedWithOption, setProceedWithOption] = useState()
    const [location, setLocation] = useState()
    const [isChecked, setIsChecked] = useState(true)
    const [skipPayment, setSkipPayment] = useState(false)
      //container
      const RadioContainer = styled.div`
      width: 100%;
      display: block;
      flex-direction: column;
      margin: 15px 0;
      position: relative;
      box-sizing: border-box;
      font-size: 15px;
      color: #505050;
      float: left;
    
      & > label {
        margin-left: 8px;
        margin-bottom: 5px;
        color: #505050;
        font-size: 16px;
        background-color: #fff;
        padding: 2px 5px;
        z-index: 999;
        position: relative;
        display: inline-block;
        cursor: default;
        max-width: 100%;
        & > .radio-label {
          text-align: center;
        }
      }
    
      .card {
        border-radius: 1rem;
        padding: 1rem 0;
        border-radius: 15px;
        background-color: #fff;
        position: relative;
        margin: 0px;
        margin-bottom: 0px;
        cursor: pointer;
        height: 9rem;
        margin-top: 0px;
        box-shadow: 0px 0px 20px #ccc;
        transition: all 200ms;
    
        .amount {
          color: black;
          margin-bottom: 2rem;
          margin-left: 6.5rem;
          border-left: 1px solid #ccc;
          padding-left: 1.5rem;
          height: 3rem;
          font-size: 21px;
        }
        .desc {
          padding: 0.8rem;
          background: #ededed;
          color: black;
          text-align: center;
        }
      }
    
      /*Check tick start  */
      .checked {
        background: #ededed;
        color: #ededed;
        position: absolute;
        left: 2rem;
        top: 1rem;
        height: 2.5rem;
        width: 2.5rem;
        border-radius: 50%;
        padding: 8px;
        & > * {
          font-size: 1.2rem;
        }
      }
    
      input:checked ~ .card .checked {
        background: #fff;
        
        color: var(--lumiq-card-bg);
      }
      /*Check tick end */
    
      .icon-container {
        font-size: 3rem;
        padding: 1rem;
        span {
          border-radius: 50%;
          padding: 1rem;
    
          background: #3e505d;
          .hero-icon {
            padding-top: 8px;
            color: #fff;
          }
        }
      }
    
      input:checked ~ .card {
        background-color: var(--lumiq-card-bg);
        color: #fff;
        .icon-container-1 {
          span {
            background: #fff;
            .hero-icon {
              color: #3e505d;
            }
          }
        }
    
        .amount {
          color: white;
          margin-bottom: 2rem;
          margin-left: 6.5rem;
          border-left: 1px solid #ccc;
          padding-left: 1.5rem;
          // padding-top: .5rem;
          height: 3rem;
          font-size: 21px;
        }
        .desc {
          padding: 0.8rem;
          background: #ffffff;
          color: black;
          text-align: center;
        }
      }
    
      input:not(:checked) ~ .card {
        /* opacity: 0.5; */
        .amount{
          color:#818181;
        }
    
        .desc{
          color:#3e505d;
        }
      }
    `

    async function downloadLinkOfPdf(Base64Pdf) {
      // if(!location){
      //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
      //     Base64Pdf: Base64Pdf,
      //   })
      //   setLocation(result.data.location)
      //   window.open(result.data.location,"_self");
      // }else{
      //   window.open(location,"_self");
      // }
      const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        var byteCharacters = atob(Base64Pdf)
        var byteNumbers = new Array(byteCharacters.length)
        for (var i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        var byteArray = new Uint8Array(byteNumbers)
        var blob = new Blob([byteArray], { type: "application/pdf" })
        window.navigator.msSaveOrOpenBlob(blob, fileName)
        return
      }
      // For Other Browsers
      const linkSource = "data:application/pdf;base64," + Base64Pdf
      const link = document.createElement("a")
      link.href = linkSource
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      link.remove()
  
      window.addEventListener(
        "focus",
        function () {
          URL.revokeObjectURL(link.href)
        },
        { once: true }
      )
    }
  
    const handleOnChange = () => {
      setIsChecked(!isChecked);
    };
  
    const downloadPdf = async () => {
      let sendEmailPdfData = pdfData
      if (!sendEmailPdfData) {
        if (!biApiData) {
          return
        } else {
          let pdfResult = await pdfDownload({
            applicationNumber: journeyState.applicationNo,
            TID: biApiData?.TransactionId || "",
          })
          setPdfData(pdfResult.data.Base64Pdf)
          sendEmailPdfData = pdfResult.data.Base64Pdf
        }
      }
      downloadLinkOfPdf(sendEmailPdfData)
    }
  
    const printPdf = async () => {
      if (pdfData) {
        printPdf1(pdfData)
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData?.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        printPdf1(pdfResult?.data?.Base64Pdf)
      }
  
      function printPdf1(base64Data) {
        const newWindow = window.open("", "", "width=100, height=100")
        if (newWindow) {
          const document = newWindow.document.open()
          document.close()
          newWindow.moveTo(0, 0)
          newWindow.resizeTo(window.screen.width, window.screen.height)
          const contentType = "application/pdf"
          const b64Data = base64Data
          const blob = b64toBlob(b64Data, contentType)
          const blobUrl = URL.createObjectURL(blob)
          document.write(`<iframe id="pdfDocument"
          src="${blobUrl}" 
          width="100%"
          height="100%"
          frameBorder="0" ></iframe>`)
          const docs = document.getElementById("pdfDocument")
          setTimeout(() => {
            docs.contentWindow.print()
          }, 1000)
        }
      }
      function b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || ""
        sliceSize = sliceSize || 512
  
        var byteCharacters = atob(b64Data)
        var byteArrays = []
  
        for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
        ) {
          var slice = byteCharacters.slice(offset, offset + sliceSize)
  
          var byteNumbers = new Array(slice.length)
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i)
          }
  
          var byteArray = new Uint8Array(byteNumbers)
  
          byteArrays.push(byteArray)
        }
  
        var blob = new Blob(byteArrays, { type: contentType })
        return blob
      }
    }
  
    const sendEmail = async (callS3uploadPdf) => {
      if (!biApiData) {
        return
      }
      let payload = {
        journeyId: journeyState.journeyId,
        module: "BIEMAIL",
        applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
        TID: biApiData?.TransactionId || "",
      }
      sendEmailBI(payload).then(res => {
        console.log(res, "emailRes")
        if (res?.status) {
          successToastr(res.message)
        } else {
          errorToastr(res.message)
        }
      })
    }
  
    //async function to make API call
    const getData = async () => {
      console.log("journeyState",journeyState.journeyId);
      let applicationDetailsPayload = {
        _id: journeyState.journeyId,
      }
      let applicationResult = await fetchApplicationDetails(
        applicationDetailsPayload
      )
  
      let payload = {
        journeyId: journeyState.journeyId,
        allRowData: true,
      }
      let journeyResult = await fetchAllJourneyData(payload)
      console.log("journeyresult",journeyResult);
      if (journeyResult?.lifeAssuredDetails?.proceedWith) {
        setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
      }
      if(journeyResult?.journeyType?.toLowerCase() === "canarapos"){
        setPayNowOrLater("later")
      }
      generateBI(payload).then(async data => {
        console.log(journeyResult, data, "vjhdvhhs")
        setAllJourneyData(journeyResult)
        if(journeyResult?.productDetails?.nVestFundDetails){
          let fund = journeyResult?.productDetails?.nVestFundDetails
          console.log(fund)
          let finalData = {}
          Object.keys(fund).forEach(path => {
            let fundName
            let allocationPercentage
            fundName = fund[path].fundId
            allocationPercentage = fund[path].fundPercent
            console.log(fundName)
            finalData[fundName] = allocationPercentage
          })
          console.log(finalData.ELEF)
          setFundValue(finalData)
        }
        setJourneyState(prev => {
          return {
            ...prev,
            premium: Math.round(JSON.parse(data?.data?.BIJson)?.[0].MODAL_PREM_DISP) || 0,
            journeyData: applicationResult.applicationData,
          }
        })
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: data.data.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        setBiApiData(data.data)

        getTOFpaymentReceipt(journeyState.applicationNo)
        .then(res => {
          console.info(res);
          const receipts = res.data || [];
          const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
          let sum = 0;
          validReceipts.forEach(receipt => {
            sum += parseInt(receipt.amount);
          });
          if (sum >= (Math.round(JSON.parse(data.data.BIJson)?.[0].MODAL_PREM_DISP))) {
            setSkipPayment(true);
          }
          setJourneyState(prev => ({
            ...prev,
            receipts: validReceipts 
          }));
        })
        .catch(err => console.info(err));

      })
      .catch(err => {
        console.log("error in save application of save application and call BI function")
      })
    }
  
    const handleEnterPayoutOption = (event, value) => {
      console.log(event.key);
      if (event.key == 'Enter') {
        handlePayOption({ target: { value: value } })
      }
  
    }
  
    //Use Effects
    useEffect(async () => {
      console.log("getdata callaed");
      await getData();
      console.log("bidattttaaaa",biApiData);
    }, [])
  
    // useEffect(() => {
    //   storePdfData()
    // }, [biApiData])
  
    //Page Functions
    const handlePayOption = ({ target }) => {
      console.log(target.value, "value in BI");
      if (target.value === "now") {
        setPayNowOrLater("now")
      } else if (target.value === "later") {
        setPayNowOrLater("later")
      }
    }
  
    const handlePrevious = () => {
      try {
        const payload = {
          journeyId: journeyState.journeyId, 
          buttonClicked:  "Previous", 
        };
        updateUserTrackerDetails(payload)
          .then((response) => {
            if (response?.status) {
              console.log("UserTracker updated successfully:", response.message);
            } else {
              console.error("Error in updating UserTracker:", response?.message);
            }
          })
          .catch((error) => {
            console.error("Error in updateUserTrackerDetails API call:", error);
          })
      } catch (error) {
        console.error("Error in handlePrevious:", error);
      }
      if (proceedWithOption === "manually") {
        props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
        setJourneyState(prev => {
          return {
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      }
    }
  
    // code of tab enter
    const handleEnterPrevious = (event) => {
      if (event?.key == 'Enter') {
        handlePrevious();
      }
    }
    // code of tab enter
    const handleEnterDownload = (event) => {
      if (event?.key == 'Enter') {
        downloadPdf();
      }
    }
    // code of tab enter
    const handleEnterPrint = (event) => {
      if (event?.key == 'Enter') {
        printPdf();
      }
    }
    // code of tab enter
    const handleEnterEmail = (event) => {
      if (event?.key == 'Enter') {
        sendEmail(true);
      }
    }
    // code of tab enter
    const handleEnterRecalculate = (event) => {
      if (event?.key == 'Enter') {
        handleReCalculate();
      }
    }
  
    const handleProceed = async ev => {
      ev.preventDefault()
      if (!isChecked) {
        return;
      }
      console.log("tessttttttxxxxxxxxxxx",props);

      // downloadLinkOfPdf(pdfData);
      sendEmail(true);
      const ageBI=calculateAge(allJourneyData?.lifeAssuredDetails?.dob)

      // const result = await s3uploadPdfBI({
      //   applicationNumber: journeyState.applicationNo,
      //   Base64Pdf: pdfData,
      // })
      // const b64Data = pdfData
      // const blob = b64toBlob(b64Data, "application/pdf")
      // let formData = new FormData()
      // if (blob) {
      //   const file = blob
      //   formData.append("doc", file)
      //   formData.append("sub", false)
      //   formData.append("docPurpose", "BIPDF")
      //   try {
      //     const res = await uploadDocument(formData, journeyState.applicationNo)
      //     console.log({ res })
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }
      // function b64toBlob(b64Data, contentType, sliceSize) {
      //   contentType = contentType || ""
      //   sliceSize = sliceSize || 512
  
      //   var byteCharacters = atob(b64Data)
      //   var byteArrays = []
  
      //   for (
      //     var offset = 0;
      //     offset < byteCharacters.length;
      //     offset += sliceSize
      //   ) {
      //     var slice = byteCharacters.slice(offset, offset + sliceSize)
  
      //     var byteNumbers = new Array(slice.length)
      //     for (var i = 0; i < slice.length; i++) {
      //       byteNumbers[i] = slice.charCodeAt(i)
      //     }
  
      //     var byteArray = new Uint8Array(byteNumbers)
  
      //     byteArrays.push(byteArray)
      //   }
  
      //   var blob = new Blob(byteArrays, { type: contentType })
      //   return blob
      // }
  
      if (payNowOrLater === "now") {
        console.log("tesstttttt",journeyState.journeySteps.pages);
        let temp = journeyState.journeySteps
        if(["fillProposalForm", "PageFlexiEdgeFillProposalForm"].includes(temp.pages[2].pageId)){
          let element = temp.pages[3]
          temp.pages.splice(3, 1)
          temp.pages.splice(2, 0, element)
        }
        setJourneyState(prev => {
          return {
            ...prev,
            journeySteps: temp,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            paymentStep: "N",
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      console.log("journeystateeee",journeyState);

      }else{
        console.log("tesstttttt",journeyState.journeySteps.pages);

        let temp = journeyState.journeySteps
        if(["makePayment"].includes(temp.pages[2].pageId)){
          let element = temp.pages[3]
          temp.pages.splice(3, 1)
          temp.pages.splice(2, 0, element)
        }
        setJourneyState(prev => {
          return {
            ...prev,
            journeySteps: temp,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex,
            premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
            lastPageCode: props.pageId,
            lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            paymentStep: "L",
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex].sectionId
            ),
          }
        })
      }
      console.log("journeystateee222222222222222e",journeyState);
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
      let sendPayload = {
        applicationData: journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          paymentStep: payNowOrLater === "now" ? "N" : "L",
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP),
          planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null,
        ageAtBI:ageBI

        },
        posDashboardListingData:{
          canaraPosCaseType: "sendCaseToCustomer"
        }
        // base64Data: pdfData,
      }
      saveApplication(sendPayload).then(res => {
        console.log(res, "application response")
        props.setCurrentPageIndex(prev => prev + 1)
        setErrorState({})
        setErrorState({})
        setErrorState({})
        setErrorState({})
        props.setCurrentSectionIndex(0) 
        setSectionState(prev => {
          // making section data empty to load new sectionData
          return {
            ...prev,
            sectionId: null,
            sectionFirstPass: null,
            sectionData: {},
          }
        })
      }).catch(err => {
        console.log(err, "err in saveApplication benefit-illustration")
      })
    }
  
    const handleProceedSkipPayment = (e) => {
      e.preventDefault();
    
      const temp = journeyState.journeySteps;
      console.log(temp);
      let makePaymentPageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
      let fillProposalFormPageIndex = temp.pages.findIndex(page => page.pageId === "PageFlexiEdgeFillProposalForm");
      let makePaymentPageSections = temp.pages[makePaymentPageIndex].sections;
      makePaymentPageSections = makePaymentPageSections.filter(section => section.sectionId === "eNach-physicalMandate");
      temp.pages[makePaymentPageIndex].sections = makePaymentPageSections;
      let tempPage = temp.pages[makePaymentPageIndex];
      temp.pages[makePaymentPageIndex] = temp.pages[fillProposalFormPageIndex];
      temp.pages[fillProposalFormPageIndex] = tempPage;
      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp
        }
      });
    
      let sendPayload = {
        applicationData: journeyState.journeyData,
        skipPayment:'Y',
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex + 1,
          lastSection: 0,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          premium: Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP) || 0,
          lastPageCode: props.pageId,
          paymentStep: "N",
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          planOption: journeyState.planOption,
          canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
        },
        // base64Data: pdfData,
      }
    
      saveApplication(sendPayload).then(async res => {
        console.log(res, "application response");
        props.setCurrentPageIndex(prev => prev + 1);
        setErrorState({});
        props.setCurrentSectionIndex(0); // this moves to first section of next page
    
        // Save transaction details if skipPayment is true
        if (skipPayment) {
          const validReceipts = journeyState.receipts || [];
          const transactions = validReceipts.map(receipt => transformReceiptToTransaction(receipt, journeyState));
    
          const transactionPayload = {
            journeyId: journeyState.journeyId,
            applicationNumber: journeyState.applicationNo,
            status: 'Success',
            skipPayment: 'Y',
            transactions: transactions
          };
    
          let saveResp = await saveTransactionDetails(transactionPayload);
        }
        
  
      }).catch(err => {
        console.log(err, "err in saveApplication benefit-illustration");
      });
    }

    const handleReCalculate = () => {
        props.setCurrentPageIndex(0)
        props.setCurrentSectionIndex(0)
        const tempPage = journeyState.journeyData[0]
        // user activity
        try {
        const payload = {
        journeyId: journeyState?.journeyId, 
        buttonClicked: "ReCalculate", 
        };
        updateUserTrackerDetails(payload)
        .then((response) => {
        if (response?.status) {
        console.log("UserTracker updated successfully:", response.message);
        } else {
        console.error("Error in updating UserTracker:", response?.message);
        }
        })
        .catch((error) => {
        console.error("Error in updateUserTrackerDetails API call:", error);
        })
         } catch (error) {
        console.error("Error in handleReCalculate:", error);
        }
        setPageState(prev => {
          return {
            ...prev,
            pageId: tempPage.pageId,
            pageData: tempPage.pageData,
          }
        })
        const tempState = journeyState.journeyData[0].pageData[0]
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: tempState.sectionId,
            sectionData: tempState.sectionData,
          }
        })
    }  

    const handleSendLinkToSales = (ev) => {
      ev.preventDefault()
      if (!isChecked) {
        return;
      }
      sendEmail(true);
      console.log("tesstttttt",journeyState.journeySteps.pages);
      let temp = journeyState.journeySteps

      temp.pages = temp.pages.filter(page => page.pageId !== "PageFlexiEdgeFillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "PageFlexiEdgeUploadDocuments")
      temp.pages.push(...lookup.sendLinktosales)
      if(allJourneyData?.productDetails?.premiumFrequency === "SG"){
        temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
      }
      console.log(temp.pages)

      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "L",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
          canaraPosCaseType: "sendLinktosales"
        }
      })
    console.log("journeystateeee",journeyState);
    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      }
    })
    //let optInPayload = {
    //   "mobileNo": allJourneyData.salesAgentDetails.mobileNo
    // }
    // let whatsAppOptres = whatsAppOptin(optInPayload)
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        planOption: journeyState.planOption,
        canaraPosCaseType: "sendLinktosales"
      },
      posDashboardListingData:{
        canaraPosCaseType: "sendLinktosales"
      }
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      successToastr('Application will be visible on sales Dashboard after SCR Declaration')
      props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      props.setCurrentSectionIndex(0) 
      setSectionState(prev => {
        // making section data empty to load new sectionData
        return {
          ...prev,
          sectionId: null,
          sectionFirstPass: null,
          sectionData: {},
        }
      })
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration")
    })
    }


    let personalDetails = [
      {
          q1: "Name of the Prospect/ Policyholder:",
          ans1:  (allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) : (wordCapital(allJourneyData?.lifeAssuredDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.lastName))) || "",
          q2: "Age & Gender:",
          ans2:  `${(allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"? (getAge(allJourneyData?.proposerDetails?.dob)) :(getAge(allJourneyData?.lifeAssuredDetails?.dob)))} | ${ (allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N"? lineCapital(getValueFromLookup("gender",allJourneyData?.proposerDetails?.gender)) :lineCapital(getValueFromLookup("gender",allJourneyData?.lifeAssuredDetails?.gender)))}`
      },
      {
          q1: "Name of the Life Assured:",
          ans1: `${wordCapital(allJourneyData?.lifeAssuredDetails?.firstName ?? '')+ " " + wordCapital(allJourneyData?.lifeAssuredDetails?.middleName ?? '')+ " " + wordCapital(allJourneyData?.lifeAssuredDetails?.lastName)}`,
          q2: "Age & Gender:",
          ans2:`${(getAge(allJourneyData?.lifeAssuredDetails?.dob))} | ${lineCapital(getValueFromLookup("gender",allJourneyData?.lifeAssuredDetails?.gender))}`
      },
      {
          q1: "Sum Assured:",
          ans1: allJourneyData?.productDetails?.sumAssured,
          q2: "Plan Option",
          ans2: allJourneyData?.productDetails?.planOption === "ULTPF1" ? "Invest Plus" : allJourneyData?.productDetails?.planOption === "ULTPF2" ? "Invest Plus - SP" : allJourneyData?.productDetails?.planOption === "ULTPF3" ? "Premium Plus" : "Life Plus" 
      },
      {
          q1: "Policy Term & Premium Payment Term:",
          ans1: `${allJourneyData?.productDetails?.policyTerm || "NA"} / ${allJourneyData?.productDetails?.premiumPaymentTerm === "A99" ? (100 -getAge(allJourneyData?.lifeAssuredDetails?.dob))  : allJourneyData?.productDetails?.premiumPaymentTerm || "NA"}`,
          q2: "Mode of payment of premium:",
          ans2:`${lineCapital(getValueFromLookup(
            "premiumFrequency",
            allJourneyData?.productDetails?.premiumFrequency
          ) ?? '') || "NA"}`,
      },
      {
          q1: "Amount of Installment Premium",
          ans1: `${biApiData ? JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP : ""}`,
          q2: "Staff/ Non Staff",
          ans2: `${(allJourneyData?.lifeAssuredDetails?.employmentDetails?.staff === "Y" ? "Yes" : "No") || "NA"}`
      },
      {
        q1: "Employer/Organisation",
        ans1: getValueFromLookup("companyList", allJourneyData?.lifeAssuredDetails?.employmentDetails?.employerName) || "NA",
    }
  ]
  return (
    <>
      <style>
        {`
        .table-design .table-bg{
          border:none;
        }

        .option-buit-design-new-new-design::after{
          height: 2rem
        }
        .shadow-box-card{
          background-color: #fff;
          box-shadow: 0px 0px 10px #ccc;
          border-radius: 10px;
          padding: 0px 0px;
          float: left;
          width: 100%;
          margin-bottom: 30px;
          height: 172px;
        }
        .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
          background-color: #ededed;
          left: 0px;
          top: 0px;
        }
        radio-line{
          width: 100%;
          height: 100%
        }
        .customradio{
          padding: 22px 0px
        }
        .customradio .checkmark {
          top: 22px !important;
        }
        .by-pay{
          bottom: 8px
        }
        resent-bi-center{
          position: relative;
        }
        .eky-resend {
          margin: auto;
          right: 25px;
          position: relative;
          left: 4px
        }
        .custom-otp{
          margin: auto
        }
      
      `}

      </style>
      {allJourneyData && biApiData && (<div className='container'>
        <form id="declaration-form" name="declaration-form" action method="post" autoComplete="off" noValidate="novalidate">
          <div className="iselect-padding mt-20">
            <div className="iselect-box-design mb">
              <div className="heading-design">
                <div className="iselect-padding left-side-head">
                  <h1 className="iselect-heading">Benefit Illustration</h1>
                  <span className="subhead">Canara HSBC Life Insurance Wealth Edge Plan &nbsp; |  &nbsp; UIN: 136L085V01 </span> </div>
                <div className="app-quatation mt hidden-desktop-screen">
                  <div className="application-design-number">Application Number: {journeyState.applicationNo}</div>
                </div>
              </div>
              <div className="bi-summary">
                <div className="auther-description mt-20">
                    <h3>
                    Dear{" "}
                    {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                       { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.proposerDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.proposerDetails?.title === "MRS" ?  'Mrs. ' : ""
                          : (allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. ': ``)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.gender.toUpperCase() == "M" || allJourneyData?.proposerDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                          : (allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "M" || allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }
                    </h3>
                  <p className="benefit-title">Thank you for showing interest in our Canara HSBC Life Insurance Wealth Edge Plan. Based on the details provided by you, and reproduced below, the illustration customised to your requirements is appended.
                  <br/>
                  <br/>
                  Please note that this illustration is indicative and the actual values may vary depending on performance of the participating fund managed by the Company.
                  </p>
                </div>
              </div>
              <div className="Bi-design-structure-table mt-50 iselect-mg-bottom">
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table">Personal Details of Life to be Assured</h2>
                    <div className="table-bg">
                      <table className="table">
                        <tbody>
                            {personalDetails.map((elem, index)=>{
                              return(
                              <tr className={`table-color${index%2==0?"-grey":""}`}>
                                  <td width="33%">{elem.q1}</td>
                                  <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>{elem.ans1}</td>
                                  <td width="26%" align="left">{elem.q2}</td>
                                  <td width="24%" align="right">{elem.ans2}</td>
                              </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="col-md-12">
                <div className="table-responsive table-design">
                  <div className="table-bg">
                    <table className="table">
                    <tbody>
                    <tr className="headline-table brd-flexi-product" style={{color: '#fff !important'}}>
                      <td colSpan={4} align="center">Plan Details</td>
                    </tr>
                    <tr className={`table-color${2%2==0?"-grey":""}`}>
                      <td width="33%">Name of the Product:</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>{(getValueFromLookup(
                            "planOption",
                            allJourneyData?.productDetails?.planOption
                          ) ?? '') || "NA"}</td>
                      <td width="26%" align="left"> Tagline</td>
                      <td width="24%" align="right"> An Individual Linked Life Insurance cum Savings Plan</td>
                    </tr>
                    <tr className={'table-color'} >
                      <td  width="33%" align="left"> Unique Identification No:</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>136L085V01</td>
                      <td width="26%" align="left"> GST Rate:</td>
                      <td width="24%" align="right"> 18.0%</td>
                    </tr>
                    <tr className={'table-color-grey'}>
                      <td  width="33%" align="left"> Investment Strategy Opted for: SSO (Y/N)	</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>
                      {lineCapital(getValueFromLookup(
                            "yesNo",
                            allJourneyData?.productDetails?.safetySwitchOption
                          ) ?? '') || "NA"}
                      </td>
                      <td width="26%" align="left">Investment Strategy Opted for: STO (Y/N)</td>
                      <td width="24%" align="right"> 
                      {lineCapital(getValueFromLookup(
                            "yesNo",
                            allJourneyData?.productDetails?.sysTransferOption
                          ) ?? '') || "NA"}</td>
                    </tr>
                    <tr className={'table-color'} >
                      <td  width="33%" align="left"> If STO, Target Fund</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>
                      {allJourneyData?.productDetails?.sysTransferOption === "Y" ? lineCapital(getValueFromLookup(
                            "StoTargetFunds",
                            allJourneyData?.productDetails?.chooseTargetStoFund
                          ) ?? '') || "NA" : "NA"}
                      </td>
                      <td width="26%" align="left"> Systematic Withdrawal Option</td>
                      <td width="24%" align="right">
                      {lineCapital(getValueFromLookup(
                            "yesNo",
                            allJourneyData?.productDetails?.withdrwalOption
                          ) ?? '') || "NA"}
                      </td>
                    </tr>
                    <tr className={'table-color-grey'}>
                      <td  width="33%" align="left"> Systematic Withdrawal % (of fund value) per Annum</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>
                      {allJourneyData?.productDetails?.withdrwalOption === "Y" ? lineCapital(getValueFromLookup(
                            "SwoFundValueWithdrawn",
                            allJourneyData?.productDetails?.fundValueWithdrwalYear
                          ) ?? '') || "NA" : "NA"}
                      </td>
                      <td width="26%" align="left"> Systematic Withdrawal Payout Frequency</td>
                      <td width="24%" align="right">
                      {allJourneyData?.productDetails?.withdrwalOption === "Y" ? lineCapital(getValueFromLookup(
                            "SwoFrequency",
                            allJourneyData?.productDetails?.chooseFreqSwo
                          ) ?? '') || "NA" : "NA"}
                      </td>
                    </tr>
                    <tr className={'table-color'}>
                      <td  width="33%" align="left"> Milestone Withdrawal Option</td>
                      <td width="17%" align="right" className="rd-tatav" style={{"borderRight":"1px solid #999999"}}>
                      {lineCapital(getValueFromLookup(
                            "yesNo",
                            allJourneyData?.productDetails?.milestoneWithdrawal
                          ) ?? '') || "NA"}
                      </td>
                      <td width="26%" align="left"></td>
                      <td width="24%" align="right">
                      </td>
                    </tr>
                    </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="col-md-12">
                <div className="table-responsive table-design">
                  <div className="table-bg">
                    <table className="table">
                      <tbody>
                        <tr className="headline-table brd-flexi-product" style={{color: '#fff !important' , borderBottom:"1px solid"}}>
                          <td colSpan={4} align="center">Fund Allocation</td>
                        </tr>
                        <tr className={'table-color-grey'} style={{"background-color":" var(--lumiq-card-bg)", "color": "#fff"}}>
                          <th width="33%" align="center">Fund</th>
                          <th width="27%" align="center" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}>SFIN No</div> </th>
                          <th width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>Allocation</div> </th>
                          <th width="14%" align="right"><div style={{"float":"right"}}> Risk</div></th>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left"> Large Cap Advantage Fund:</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF02109/06/20LARCPEQFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.LCAF: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left"> Emerging Leaders Equity Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF02020/12/17EMLEDEQFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.ELEF: `0`}%</div> </td>
                          <td width="24%" align="left"> <div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left">India Multi-Cap Equity Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF01816/08/16IMCAPEQFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.IMEF: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left">Equity II Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF00607/01/10EQUTYIIFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.PEF2: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> High</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left">Growth Plus Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF00913/09/10GROWTPLFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.GWF3: `0`}%</div> </td>
                          <td width="24%" align="right"><div style={{"float":"right"}}> Medium to High</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left">Balanced Plus Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF01013/09/10BLNCDPLFND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.BLF3: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> Medium</div></td>
                        </tr>
                        <tr className={'table-color'}>
                          <td  width="33%" align="left">Debt Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF00409/07/08INDEBTFUND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.BDF1: `0`}%</div> </td>
                          <td width="24%" align="right"><div style={{"float":"right"}}> Medium to High</div></td>
                        </tr>
                        <tr className={'table-color-grey'}>
                          <td  width="33%" align="left">Liquid Fund</td>
                          <td width="17%" align="left" className="rd-tatav"><div style={{"display":"flex", "justifyContent": "space-around"}}> ULIF00514/07/08LIQUIDFUND136</div></td>
                          <td width="26%" ><div style={{"display":"flex", "justifyContent": "space-around"}}>{fundValue ? fundValue.CSF1: `0`}%</div> </td>
                          <td width="24%" align="left"><div style={{"float":"right"}}> Low</div></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="clearfix" />

              <div className="transactionDetailsWrap">
                <div className="detailContentWrap">
                  <div className="row">
                    <div className="buttonWrap">
                      <div 
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterDownload(e)}
                        onClick={downloadPdf}
                        >
                          <a> Download</a></div>
                      <div 
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterPrint(e)}
                        onClick={printPdf}
                      >
                        <a> Print</a></div>
                      <div 
                        className="button submit-btn"
                        aria-hidden="true"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterEmail(e)}
                        onClick={() => {sendEmail(true)}}
                      >
                        <a> Email</a></div>
                      <div 
                      className="button submit-btn"
                      aria-hidden="true"
                       style={{
                        cursor:
                          proceedWithOption === "manually"
                            ? "pointer"
                            : "default",
                      }}
                      tabIndex="0"
                      disabled={
                        proceedWithOption === "manually" ? false : true
                      }
                      onKeyPress={(e) => handleEnterRecalculate(e)}
                      onClick={handleReCalculate}
                      >
                        <a>Re-Calculate</a></div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="clearfix" />

              {/* <div className="row iAgree ls3 text-center mt-20">
                <div className="form-group">
                  <div className="inner-addon left-addon">
                    <div className="checkbox1">
                      <input name="checkboxG6" id="checkboxG6" className="css-checkbox" type="checkbox" defaultChecked />
                      <label htmlFor="checkboxG6" className="css-label"> I agree to the Disclosures and Disclaimers as mentioned below </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" /> */}
              {/* <div className="iselect-mg-bottom  mt-20 mb-30">
                <div className="col-md-12">
                  <p className="p-text text-center">OTP has been sent to your registered mobile number xxxxxxxxxx and email address test@gmail.com. It will be valid for 30 min.</p>
                  <div className="clearfix" />
                  <div className="col-md-5 col-xs-12 pl pr-30 resent-bi-center mt-30 custom-otp">
                    <label className="title-bg text-left" style={{marginLeft: '5px'}}>Enter OTP</label>
                    <input type="text" className="form-control" name="otp" placeholder="xxxx" />
                    <div className="resend-otp eky-resend"><a href="#">Resend OTP <span className="fa fa-angle-right" /></a></div>
                  </div>
                </div>
              </div>
              <div className="clearfix" /> */}
              <div className="option-buit-design-new-structure Bi-page-pay-structure mt-30">
                <div className="col-md-12">
                  <div className="option-buit-design-new-structure-box">
                  {allJourneyData?.journeyType !== "CanaraPos" && !skipPayment && (
                          <div className="option-buit-design-new-structure-selected">
                            <div className="row">
                              <div className="col-lg-6 col-md-12 col-xs-12 ">
                                <RadioContainer>
                                  <div
                                    style={{ borderRadius: "15px" }}
                                    className="provider"
                                    tabIndex="0"
                                  >
                                    <label className="width">
                                      <input
                                        type="radio"
                                        name="pay"
                                        value="now"
                                        hidden
                                        onChange={handlePayOption}
                                        checked={
                                          payNowOrLater == "now" ? true : false
                                        }
                                      />
                                      <div className="card">
                                        <div className="checked">
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            stroke-width="0"
                                            viewBox="0 0 512 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                          </svg>
                                        </div>
                                        <div className="amount">
                                          <span>
                                            Pay{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_DISP
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            Now!
                                          </span>
                                        </div>
                                        <div className="desc">
                                          <span>
                                            Pay your{" "}
                                            {lineCapital(
                                              getValueFromLookup(
                                                "biFrequencyLabel",
                                                allJourneyData?.productDetails
                                                  ?.premiumFrequency
                                              ) ?? ""
                                            ) || "NA"}{" "}
                                            Premium{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_DISP
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            now and proceed.
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </RadioContainer>
                              </div>

                              <div className="col-lg-6 col-md-12 col-xs-12 ">
                                <RadioContainer>
                                  <div
                                    style={{ borderRadius: "15px" }}
                                    className="provider"
                                    tabIndex="0"
                                  >
                                    <label className="width">
                                      <input
                                        type="radio"
                                        name="pay"
                                        value="later"
                                        hidden
                                        onChange={handlePayOption}
                                        checked={
                                          payNowOrLater == "later"
                                            ? true
                                            : false
                                        }
                                      />
                                      <div className="card">
                                        <div className="checked">
                                          <svg
                                            stroke="currentColor"
                                            fill="currentColor"
                                            stroke-width="0"
                                            viewBox="0 0 512 512"
                                            height="1em"
                                            width="1em"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                          </svg>
                                        </div>
                                        <div className="amount">
                                          <span>
                                            Pay{" "}
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_DISP
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            Later!
                                          </span>
                                          <div></div>
                                        </div>
                                        <div className="desc">
                                          <span>
                                            Continue with your application and
                                            pay
                                            {biApiData
                                              ? `₹ ${applyComma(
                                                  Math.round(
                                                    JSON.parse(
                                                      biApiData.BIJson
                                                    )?.[0].MODAL_PREM_DISP
                                                  )
                                                )}`
                                              : "NA"}{" "}
                                            later.
                                          </span>
                                        </div>
                                      </div>
                                    </label>
                                  </div>
                                </RadioContainer>
                              </div>
                            </div>
                          </div>
                      )}
                      {skipPayment && <p style={{
                        textAlign : "center",
                        fontSize : "18px",
                        marginTop : "30px"

                      }}>Premium of Rs {`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_DISP)) : "NA"}`} is adjusted against transfer of funds from old application</p>} 
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                <div className="col-md-12">
                  <div className="but-center text-center">
                  {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    }
                    <input aria-hidden="true" onClick={skipPayment ? handleProceedSkipPayment : handleProceed} className="previous-btn cen text-uppercase ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="button" value="PROCEED"  />
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                    <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                    {/* <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} /> */}
                      </span>
                    }
              
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design">
              <h2>Disclaimers</h2>
              <ul>
                <li>In this policy, the investment risk in investment portfolio is borne by the policyholder.</li>
                <li>Canara HSBC Life Insurance Company Limited is only the name of the insurance company and Canara HSBC Life Insurance Wealth Edge Plan is only the name of the linked insurance contract and does not in any way indicate the Quality of the contract, its future prospects or returns.
                </li>
                <li>The various funds offered under this contract are the names of the funds and do not in any way indicate the Quality of these plans, their future prospects and returns .The SFIN (Segregated Fund Index Number) for: Emerging Leaders Equity Fund is ULIF02020/ 12/17EMLEDEQFND136, India Multi-Cap Equity Fund is UUF01816/08/161MCAPEQFND136, Equity 11 Fund is UUF00607/01/ 10EQUTYll FND136, Growth Plus Fund is UUF00913/09/10GROWTPLFND136, Balanced Plus Fund is UUF01013/09/10BLNCDPLFND136, Debt Fund is UUF00409/07/081NDEBTFUND136, Liquid Fund is UUF005 14/07/08UQUIDFUND136 and Discontinued Policy Fund is UUF013 19/09/ 11POLDISCFND136.</li>
                <li>Please know the associated risks and the applicable charges, from your insurance agent or the intermediary or policy document issued by the insurance company.
                </li>
                <li>Unit Linked Insurance products are different from the traditional insurance products and are subject to the risk factors.</li>
                <li>Unit Linked Funds are subject to market risks and there is no assurance or guarantee that the objective of the investment fund will be achieved.</li>
                <li>The premium paid in Unit Linked Insurance policies are subject to investment risks associated with capital markets and the NAVs of the units may go up or down based on the performance of fund and factors influencing the capital market and the insured is responsible for his/her decisions.
                </li>
                <li>The Unit Linked Insurance Products do not offer any liquidity during the first five years of the contract. The policyholder will not be able to surrender/withdraw the monies invested in Unit Linked Insurance Products completely or partially till the end of the fifth year.</li>
                <li>Past performance of the investment funds do not indicate the future performance of the same. Investors in the Scheme are not being offered any guaranteed / assured returns.</li>
                <li>The fund values shown in the illustration are not guaranteed and for illustrative purposes only. The assumed rates of return (4% p.a. and 8% p.a.) shown in the illustration are not the upper or lower limits of what you might get back as the value of your policy depends on a number of factors including future investment performance.</li>
                <li>Purchase of any insurance products by a bank's customer is purely voluntary and is not linked to availment of any other facility from the bank.
                </li>
                <li>For more details on risk factors, terms and conditions please read the sales brochure carefully before concluding a sale.</li>
                <li>Collection of advance premium shall be allowed within the same financial year for the premium due in that financial year. However, where the premium due in a financial year is being collected in previous financial year, the premium may be collected for a maximum period of three months in advance of the due date of the premium. The premium so collected in advance shall only be adjusted on the due date of the premium. Such advance premium, if any, paid by the Policyholder shall not carry any interest.</li>
                <li>The premium shall be adjusted on the due date even if it has been received in advance.</li>
                <li>The premiums & funds are subject to certain charges related to the fund or to the premium paid.</li>
                <li>Medical charges will be deducted in case of non-issuance of the policy.</li>
                <li>Tax Benefits under the Policy will be as per the prevailing Income Tax laws and are subject to amendments from time to time. For tax related Queries, contact your independent tax advisor.</li>
                <li>Trade Logo of Canara HSBC Life Insurance Company Limited (Insurer) is used under license with Canara Bank, HSBC Group Management Services Limited and .</li>
                <li>The Insurance products are offered and underwritten by Insurer (IRDAI Regn.No.136) having its head office at 139 P, Sector 44, Gurugram - 122003, Haryana, India
                </li>
                <li>Corporate Identity No.-U66010DL2007PLC248825, Website:www.canarahsbclife.com. Call: 1800-103-0003/1800-180-0003/1800-891-0003. Give a missed call to:0124-6156600, SMS:9779030003, Email:customerservice@canarahsbclife.in</li>
              </ul>
            </div>
          </div>
        </div>
         {/* <!--mobile view button--> */}
          <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1 canara-pos-bi-btn">
            <div className="iselect-mg-bottom">
              <div className="col-md-12">
                <div className="but-center text-center">
                {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div
                        className="submit-btn cen"
                        style={{ marginRight: "5px" }}
                        >
                        {" "}
                        <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                        </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div
                          className="submit-btn cen"
                          style={{ marginRight: "5px" }}
                          >
                          {" "}
                          <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                          </div>
                    }
                  <div className="previous-btn cen">
                    <a>
                      {" "}
                      <button
                        aria-hidden="true"
                        value="button1"
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                          color: "#fff",
                        }}
                        onClick={skipPayment? handleProceedSkipPayment : handleProceed}
                      >
                        Proceed
                      </button>{" "}
                    </a>
                  </div>
                    {allJourneyData?.journeyType === "CanaraPos" &&
                  <div className="previous-btn cen send-link-to-cust">
                      <span>
                        <input className="previous-btn cen text-uppercase ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                      </span>
                  </div>
                    }
                  {/* <div className="previous-btn cen send-link-to-cust">
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                        <input className="previous-btn cen text-uppercase ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} />
                      </span>
                    }
                  </div> */}
                </div>
              </div>
            </div>
          </div>
          {/* <!--mobile view button-->  */}
          <div className="clearfix"></div>
          
      </div>)}

    </>

  )
}